import { Component, OnInit } from '@angular/core';
import { PageContainerService } from '../../services';
import { Router } from '@angular/router';
import { ControllerForViewBase } from '../framework/controller-for-view-base';
import { GetFeatureCommandResponse, SystemUpdateDto } from '../../data/CommandServiceDtos.generated';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  standalone: false,
  selector: 'feature-releases',
  templateUrl: './feature-releases.component.html',
  styleUrls: ['./feature-releases.component.scss']
})
export class FeatureReleasesComponent extends ControllerForViewBase implements OnInit {
  featureReleases: SystemUpdateDto[] = [];
  NewFeatures: SystemUpdateDto[] = [];

  constructor(
    public pcs: PageContainerService, private router: Router, private sanitizer: DomSanitizer
  ) { super(pcs);}

  ngOnInit() {
    this.getFeatures();
  }

  async getFeatures()
  {
    const getCommandResponse: GetFeatureCommandResponse = await this.pcs.apiService.GetFeature({});
    this.featureReleases = getCommandResponse.PastUpdates;
    this.NewFeatures = getCommandResponse.NewUpdates;
  }

  openFeature(feature: SystemUpdateDto) {
    this.router.navigate(['feature-releases', feature.Id]);
  }

  statusClass(feature: SystemUpdateDto): string {
    return `status-pill ${feature.IsActive ? 'live' : 'inactive'}`;
  }

  contentWithoutImages(content: string): SafeHtml {
    const withoutImages = (content || '').replace(/<img[^>]*>/gi, '');
    return this.sanitizer.bypassSecurityTrustHtml(withoutImages);
  }
}

